export const ITRequisitionPaths = {
  MANAGE_REQUEST_IT_REQUISITION: 'it-request',
  MANAGE_REQUEST_CREATE_IT_REQUISITION: 'create',
  MANAGE_REQUEST_EDIT_IT_REQUISITION: 'edit/:requestId',
};
